import React, { useEffect } from 'react';
import { ChevronRight, Stethoscope, Cross } from 'lucide-react';
import { useNavigate  } from 'react-router-dom';
import { motion, useAnimation, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export const Hero = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  const navigate = useNavigate();


  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  const handleFeaturedRedirect = () => {
    const section = document.getElementById("FeaturedProducts");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };



  const floatingVariants = {
    initial: { y: 0 },
    float: {
      y: [-20, 20, -20],
      transition: {
        duration: Math.random() * 8 + 5,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 z-0"
       
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900 to-teal-900/60" />
      </div>

      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full opacity-20">
          {[...Array(5)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-full h-px bg-teal-300"
              style={{ top: `${20 + i * 15}%` }}
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 0.3, 0] }}
              transition={{ duration: 2, repeat: Infinity, delay: i * 0.2 }}
            />
          ))}
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10 text-center">
        <motion.div
          ref={ref}
          initial="hidden"
          animate={controls}
          variants={{
            visible: { transition: { staggerChildren: 0.2 } },
            hidden: {},
          }}
          className="max-w-3xl mx-auto"
        >
          <motion.h1
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0 },
            }}
            className="text-5xl md:text-7xl font-bold font-poppins text-white mb-6 leading-tight"
          >
            Equipa Tu Práctica Médica con <span className="text-teal-400">Excelencia</span>
          </motion.h1>
          
              <motion.p
        variants={{
        hidden: { opacity: 0, y: 15 },
        visible: { opacity: 1, y: 0 },
      }}
      className="text-xl md:text-2xl text-teal-300 mb-8 font-light"
    >
      Instrumentos de precisión y equipamiento profesional
      <span className="hidden md:inline">
        : Estetoscopios, Batas Quirúrgicas y Material Médico de Primera Calidad
      </span>
    </motion.p>

    <motion.div
            variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate("/products")}
              className="flex items-center justify-center px-8 py-4 bg-teal-500 text-white rounded-full hover:bg-teal-600 transition-colors"
            >
              Catálogo Completo
              <motion.span whileHover={{ x: 5 }} className="ml-2">
                <ChevronRight className="h-5 w-5" />
              </motion.span>
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleFeaturedRedirect}
              className="flex items-center justify-center px-8 py-4 border-2 border-white text-white rounded-full hover:bg-white/10 transition-colors"
            >
              Productos Destacados
              <motion.span whileHover={{ rotate: 360 }} className="ml-2">
                <Stethoscope className="h-5 w-5" />
              </motion.span>
            </motion.button>
          
          </motion.div>
        </motion.div>
      </div>

      <AnimatePresence>
        {[...Array(30)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute pointer-events-none"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              scale: Math.random() * 0.8 + 0.4,
              opacity: Math.random() * 0.5 + 0.2,
            }}
            variants={floatingVariants}
            initial="initial"
            animate="float"
          >
            <Cross className="text-teal-300 h-6 w-6" />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};